import {useTranslation} from "react-i18next";
import InLayer from "./InLayer";

type Props = {
  title: string
  message: string
  onConfirm: () => void
  onCancel: () => void
}

export default (props: Props) => {
  const {t} = useTranslation()

  return (
    <InLayer
      title={props.title}
      btnConfirmLabel={t('yes')}
      btnCancelLabel={t('no')}
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
    >
      {props.message}
    </InLayer>
  )
}